import { AppNS } from 'app';
import { API_URL } from 'app/core/config';
import axios, { Canceler } from 'axios';

import { ApiNS } from '../../api';
import { getErrorMessage } from '../../helpers/errorHandling';

const ORDER_URL = 'set-order';
const INSPECTION_EVENTS_URL = 'inspectors-days';

const CancelToken = axios.CancelToken;
let cancel: Canceler;

export function apiGetInspectionEvents(
  params: AppNS.Params
): Promise<ApiNS.GetInspectionEventsApiResponse> {
  if (cancel !== undefined) {
    cancel();
  }
  return new Promise((resolve, reject) => {
    axios
      .get(`${API_URL}/${INSPECTION_EVENTS_URL}.json`, {
        cancelToken: new CancelToken(function executor(c) {
          // An executor function receives a cancel function as a parameter
          cancel = c;
        }),
      })
      .then(({ data }) => {
        if (data) {
          resolve({ ...data.model });
        } else {
          reject(getErrorMessage(data));
        }
      })
      .catch((error) => {
        reject(getErrorMessage(error));
      });
  });
}

export function apiSaveInspectionEventsOrder(
  id: string,
  inspections: AppNS.InspectionEventShort[]
): Promise<ApiNS.GetInspectionEventsApiResponse> {
  const req = {
    id,
    inspections,
  };
  return new Promise((resolve, reject) => {
    axios
      .patch(`${API_URL}/${INSPECTION_EVENTS_URL}/${ORDER_URL}.json`, req)
      .then(({ data }) => {
        if (data.model) {
          resolve(data.model);
        } else {
          reject(getErrorMessage(data));
        }
      })
      .catch((error) => {
        reject(getErrorMessage(error));
      });
  });
}
